import request from '@/utils/request'
//修改密码
export function upDataPwd(data) {
  return request({
    url: 'system/user/update-pwd',
    method: 'put',
    data: data
  })
}
//技能组下拉框
export function selGroupList() {
  return request({
    url: 'system/group/selection',
    method: 'get',
  })
}

//数据管理技能组
export function selGroupScopeList() {
  return request({
    url: 'system/group/selection-scope',
    method: 'get',
  })
}

//角色下拉框
export function selRole() {
  return request({
    url: 'system/role/selection',
    method: 'get',
  })
}
//ivr下拉框
export function selIvrList() {
  return request({
    url: 'sip/ivr/selection',
    method: 'get',
  })
}
//ivr节点列表
export function selIvrNodeList() {
  return request({
    url: 'sip/ivr-node/selection',
    method: 'get',
  })
}
//语音下拉框
export function selRingList() {
  return request({
    url: 'sip/ring/selection',
    method: 'get',
  })
}
//线路配置下拉框
export function selLineList() {
  return request({
    url: 'sip/line/selection',
    method: 'get',
  })
}

//结束吗下拉框
export function selDictList() {
  return request({
    url: 'sip/dict/selection',
    method: 'get',
  })
}
//派发接口 '根据技能组id查'
export function groupUsers(query) {
  return request({
    url: 'system/group/group-users/',
    method: 'get',
    params: query
  })
}
//模板下拉框  模板类型 1.工单模板 2.留资模板
export function callSelection(formType) {
  return request({
    url: 'sip/call-form/selection/'+formType,
    method: 'get',
  })
}
//语义下拉框
export function selSemanticList(query) {
  return request({
    url: 'sip/semantic/selection',
    method: 'get',
    params: query
  })
}

//语义下拉框
export function optionVoice() {
  return request({
    url: 'sip/ring/selection-path',
    method: 'get',
  })
}
//对接客户下拉
export function verbalTrick() {
  return request({
    url: 'sip/verbal-trick/selection',
    method: 'get',
  })
}